"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
var useBoolean_1 = tslib_1.__importDefault(require("@eduzz/houston-hooks/useBoolean"));
var houston_styles_1 = require("@eduzz/houston-styles");
var nestedComponent_1 = tslib_1.__importDefault(require("../utils/nestedComponent"));
var Content_1 = tslib_1.__importDefault(require("./Content"));
var context_1 = tslib_1.__importStar(require("./context"));
var Sidebar_1 = tslib_1.__importDefault(require("./Sidebar"));
var Topbar_1 = tslib_1.__importDefault(require("./Topbar"));
var Layout = function (_a) {
    var className = _a.className, children = _a.children, rest = tslib_1.__rest(_a, ["className", "children"]);
    var _b = tslib_1.__read(React.useState(false), 2), hasTopbar = _b[0], setHasTopbar = _b[1];
    var _c = tslib_1.__read(React.useState(false), 2), hasSidebar = _c[0], setHasSidebar = _c[1];
    var _d = tslib_1.__read(React.useState(false), 2), hasUserMenu = _d[0], setHasUserMenu = _d[1];
    var _e = tslib_1.__read(React.useState(null), 2), userMenuContainer = _e[0], setUserMenuContainer = _e[1];
    var _f = tslib_1.__read((0, useBoolean_1.default)(false), 4), userMenuOpened = _f[0], toogleUserMenuOpened = _f[1], trueUserMenuOpened = _f[2], falseUserMenuOpened = _f[3];
    var _g = tslib_1.__read((0, useBoolean_1.default)(false), 4), sidebarOpened = _g[0], toogleSidebarOpened = _g[1], trueSidebarOpened = _g[2], falseSidebarOpened = _g[3];
    var registerTopbar = React.useCallback(function () {
        setHasTopbar(true);
        return function () { return setHasTopbar(false); };
    }, []);
    var registerSidebar = React.useCallback(function () {
        setHasSidebar(true);
        return function () { return setHasSidebar(false); };
    }, []);
    var registerUserMenu = React.useCallback(function () {
        setHasUserMenu(true);
        return function () { return setHasUserMenu(false); };
    }, []);
    var registerUserMenuContainer = React.useCallback(function (div) {
        setUserMenuContainer(div);
    }, []);
    var contextValue = React.useMemo(function () { return ({
        topbar: {
            exists: hasTopbar,
            register: registerTopbar
        },
        sidebar: {
            exists: hasSidebar,
            opened: sidebarOpened,
            register: registerSidebar,
            toogleOpened: toogleSidebarOpened,
            trueOpened: trueSidebarOpened,
            falseOpened: falseSidebarOpened
        },
        userMenu: {
            opened: userMenuOpened,
            container: userMenuContainer,
            exists: hasUserMenu,
            register: registerUserMenu,
            registerContainer: registerUserMenuContainer,
            toogleOpened: toogleUserMenuOpened,
            trueOpened: trueUserMenuOpened,
            falseOpened: falseUserMenuOpened
        }
    }); }, [
        falseSidebarOpened,
        falseUserMenuOpened,
        hasSidebar,
        hasTopbar,
        hasUserMenu,
        registerSidebar,
        registerTopbar,
        registerUserMenu,
        registerUserMenuContainer,
        sidebarOpened,
        toogleSidebarOpened,
        toogleUserMenuOpened,
        trueSidebarOpened,
        trueUserMenuOpened,
        userMenuContainer,
        userMenuOpened
    ]);
    return ((0, jsx_runtime_1.jsx)(context_1.default.Provider, tslib_1.__assign({ value: contextValue }, { children: (0, jsx_runtime_1.jsx)("div", tslib_1.__assign({ className: (0, houston_styles_1.cx)(className, { 'hst-layout-has-topbar': hasTopbar }) }, rest, { children: children })) })));
};
var LayoutWrapper = (0, styled_1.default)(Layout, { label: 'hst-layout' })(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, houston_styles_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    min-height: 100vh;\n\n    &.hst-layout-has-topbar {\n      padding-top: ", "rem;\n    }\n  "], ["\n    display: flex;\n    width: 100%;\n    min-height: 100vh;\n\n    &.hst-layout-has-topbar {\n      padding-top: ", "rem;\n    }\n  "])), theme.pxToRem(context_1.TOPBAR_HEIGHT));
});
exports.default = (0, nestedComponent_1.default)(LayoutWrapper, {
    Sidebar: Sidebar_1.default,
    Content: Content_1.default,
    Topbar: Topbar_1.default
});
var templateObject_1, templateObject_2;
